<template>
  <div class="flex flex-wrap mb-4">
    <label
      v-if="$slots.default"
      class="w-1/4"
      :for="name"
    >
      <slot />
    </label>
    <div class="flex-grow">
      <input
        :id="name"
        class="rounded shadow w-full text-sm p-2 border border-gray-50 focus:bg-gray-50 focus:border-corepla-dark outline-none disabled:bg-gray-200 disabled:border-gray-300"
        :disabled="props.disabled"
        maxlength="9"
        type="text"
        :value="modelValue"
        @input="$emit('update:modelValue', $event.target.value ? parseInt($event.target.value, 10) : null)"
        @keypress="validate($event)"
      >
      <ErrorRow
        :error-fields="errorFields"
        :name="name"
        :submitted="submitted"
      />
    </div>
    <ErrorIcon
      :error-fields="errorFields"
      :name="name"
      :submitted="submitted"
    />
  </div>
</template>

<script setup>
import _ from "underscore";

import ErrorIcon from "./ErrorIcon.vue";
import ErrorRow from "./ErrorRow.vue";

const props =defineProps({
  errorFields: {
    type: Object,
    required: true
  },
  submitted: {
    type: Boolean,
    required: true
  },
  name: {
    type: String,
    required: true
  },
  modelValue: {
    type: Number,
    default: null
  },
  disabled: {
    type: Boolean,
    default: false
  }
})

defineEmits(['update:modelValue'])

const validate = (event) => {
  if (event.which < 48 || event.which > 57) {
    event.preventDefault();
    return false;
  }
  return true;
}
</script>